{
  "list": {
    "title": "Connected Systems",
    "add": "Add System",
    "columns": {
      "code": "Code",
      "name": "Name",
      "status": "Status",
      "lastUsedAt": "Last Used",
      "createdAt": "Created At"
    },
    "neverUsed": "Never used",
    "rowActions": {
      "trigger": "Actions for {{name}}",
      "rotateSecret": "Regenerate Secret Key"
    }
  },
  "drawer": {
    "createTitle": "Add System",
    "editTitle": "Edit System",
    "createDescription": "Register a system allowed to send operations to the tablets through this service.",
    "editDescription": "Update this system's name and allowed return addresses.",
    "fields": {
      "code": "Code",
      "nameAr": "Arabic Name",
      "nameEn": "English Name",
      "allowedReturnUrls": "Allowed return addresses"
    },
    "created": "System created successfully",
    "updated": "System updated successfully",
    "allowedReturnUrlsHint": "One address per line, such as https://transfers.example.com. Used when the data is filled in on the employee's device.",
    "allowedReturnUrlsInvalid": "Enter valid addresses without a path, such as https://example.com"
  },
  "secret": {
    "createTitle": "New Secret Key",
    "rotateTitle": "New Secret Key",
    "description": "Copy this secret key now. For security, it will not be shown again.",
    "copy": "Copy",
    "copied": "Copied",
    "close": "Close"
  },
  "rotateConfirmTitle": "Regenerate this system's secret key?",
  "rotateConfirmDescription": "\"{{name}}\" will stop working with its current secret key at once.",
  "statusConfirmTitle": "Change this system's status?",
  "statusConfirmDescription": "\"{{name}}\" will become {{status}}.",
  "statusChanged": "System status changed successfully",
  "secretRotated": "Secret key regenerated successfully"
}
